<table class="table table-responsive-md">
  <thead class="bg-light">
    <tr>
      <th scope="col">Datum</th>
      @if (!team) {
        <th scope="col">Team</th>
      }
      <th scope="col">Vacature</th>
      <th scope="col">Kandidaat</th>
      <th scope="col" class="text-center">Status</th>
      <th scope="col"></th>
    </tr>
  </thead>
  <tbody>
    @for (jobApplication of jobApplications | slice: (page - 1) * pageSize : page * pageSize; track jobApplication) {
      <tr>
        <td class="text-nowrap">{{ jobApplication.createdDate | date: 'shortDate' }}</td>
        @if (!team) {
          <td>{{ jobApplication.vacancy?.teamName || 'Geen' }}</td>
        }
        <td>
          @if (jobApplication.isJobApplicationForward) {
            <span
              class="badge rounded-pill text-bg-success"
              placement="right"
              ngbPopover="Deze sollicitatie is vanuit een ander team of personeelszaken aan jullie doorgestuurd."
              popoverTitle="Doorgestuurde sollicitatie"
              ><fa-icon [icon]="['fas', 'share']" size="sm"></fa-icon
            ></span>
          }
          {{ jobApplication.vacancy?.jobTitleName || 'Open Sollicitatie' }}
        </td>
        <td>{{ jobApplication | fullname }}</td>
        <td class="text-center">
          <span class="badge" [ngClass]="jobApplication.statusColor">{{ jobApplication.statusName }}</span>
        </td>
        @if (!jobApplication.isJobApplicationForward) {
          <td class="text-nowrap text-end">
            <button [routerLink]="['/admin/sollicitaties/', jobApplication.documentId]" class="btn btn-sm btn-info me-1">
              <fa-icon [icon]="['fas', 'search']"></fa-icon>
              Bekijken
            </button>
          </td>
        } @else {
          @if (jobApplication.isJobApplicationForward) {
            <td class="text-nowrap text-end">
              <button [routerLink]="['/admin/doorgestuurde-sollicitatie/', jobApplication.documentId]" class="btn btn-sm btn-info me-1">
                <fa-icon [icon]="['fas', 'search']"></fa-icon>
                Bekijken
              </button>
            </td>
          }
        }
      </tr>
    }
  </tbody>
</table>
@if (jobApplications?.length > 0) {
  <div class="d-flex justify-content-center">
    <ngb-pagination
      [rotate]="true"
      [boundaryLinks]="true"
      [(page)]="page"
      [pageSize]="pageSize"
      [maxSize]="10"
      [collectionSize]="jobApplications.length"
    ></ngb-pagination>
  </div>
}
